import { ButtonDownloadReviewComponent, ButtonDownloadReviewModifyComponent } from '@app/shared';
import { EventEmitter } from '@angular/core';

export class DocsConfig{
  // se emite cada vez que se realiza una accion con los botones de la tabla
  accion: EventEmitter<any> = new EventEmitter();
  accionModify: EventEmitter<any> = new EventEmitter();
  // contiene la configuracion de la tabla
  settings = {};
  settingsHistoryModify = {};

  constructor (taskStatus:boolean=true) {
    const self = this;
    this.settings = {
      mode: 'external',
      noDataMessage: 'La tarea actual no contiene documentos para subir',
      actions: false,
      attr: {
        class: 'table-bordered table-hover'
      },
      columns: {
        clasificacion: {
          editable: false,
          addable: false,
          title: 'Nombre documento',
          filter: {
            inputClass: 'form-control',
          },
        },
        documentos_detalle: {
          title: 'Documento',
          filter: false,
          type: 'custom',
          renderComponent: ButtonDownloadReviewComponent,
          onComponentInitFunction(instance: any) {
            instance.taskStatus = taskStatus;
            instance.save.subscribe((data: any) => {
              // controla el evento click del boton
              self.accion.emit(data);
            });
          }
        },
      },
    };
    this.settingsHistoryModify = {
      mode: 'external',
      noDataMessage: 'La el documento no contiene modificaciones',
      actions: false,
      attr: {
        class: 'table-bordered table-hover'
      },
      columns: {
        fecha: {
          editable: false,
          addable: false,
          title: 'Fecha',
          filter: {
            inputClass: 'form-control',
          },
          valuePrepareFunction: (cell: any, row: any) => {
            if (row.fecha) {
              const date = new Date(row.fecha);
              return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();;
            }else{
              return '';
            }
          },
        },
        motivo: {
          editable: false,
          addable: false,
          title: 'Motivo',
          filter: {
            inputClass: 'form-control',
          },
        },
        responsable: {
          editable: false,
          addable: false,
          title: 'Responsable',
          filter: {
            inputClass: 'form-control',
          },
          valuePrepareFunction: (cell: any, row: any) => {
            if (row.responsable) {
              return row.responsable.nombres + ' ' + row.responsable.apellidos;
            }else{
              return '';
            }
          },
        },
        fecha_aprobacion: {
          editable: false,
          addable: false,
          title: 'Fecha de aprobación',
          filter: {
            inputClass: 'form-control',
          },
          valuePrepareFunction: (cell: any, row: any) => {
            if (row.fecha_aprobacion) {
              const date = new Date(row.fecha_aprobacion);
              return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();;
            }else{
              return '';
            }
          },
        },
        responsable_aprobacion: {
          editable: false,
          addable: false,
          title: 'Responsable de Aprobación',
          filter: {
            inputClass: 'form-control',
          },
          valuePrepareFunction: (cell: any, row: any) => {
            if (row.responsable_aprobacion) {
              return row.responsable_aprobacion.nombres + ' ' + row.responsable_aprobacion.apellidos;
            }else{
              return '';
            }
          },
        },
        motivo_rechazo: {
          editable: false,
          addable: false,
          title: 'Motivo de rechazo',
          filter: {
            inputClass: 'form-control',
          },
        },
        aprobacion: {
          editable: false,
          addable: false,
          title: 'Aprobado',
          filter: {
            inputClass: 'form-control',
          },
          valuePrepareFunction: (cell: any, row: any) => {
            if (row.fecha_aprobacion) {
              return row.aprobacion ? 'Si' : 'No';
            }else{
              return '';
            }
          },
        },
        id: {
          title: 'Documento',
          filter: false,
          type: 'custom',
          renderComponent: ButtonDownloadReviewModifyComponent,
          onComponentInitFunction(instance: any) {
            instance.taskStatus = taskStatus;
            instance.save.subscribe((data: any) => {
              // controla el evento click del boton
              self.accionModify.emit(data);
            });
          }
        },
      },
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/forms/all/modify-document/shared/modify-document-config.service.ts